import { useState } from 'react';

const DEFAULT_PAGE_SIZE = 10;

export function usePagination({ items, itemsPerPage = DEFAULT_PAGE_SIZE }) {
  const [page, setPage] = useState(1);
  const paginate = (items) => {
    return items.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  }

  const handleGoToPage = (page) => {
    setPage(page);
  }

  const handlePageNext = () => {
    setPage(prevPage => prevPage + 1);
  }

  const handlePagePrevious = () => {
    setPage(prevPage => prevPage > 1 ? prevPage - 1 : prevPage);
  }

  const totalPageCount = Math.ceil(items.length / itemsPerPage);

  return {
    page,
    handleGoToPage,
    handlePageNext,
    handlePagePrevious,
    totalPageCount,
    paginatedItems: paginate(items)
  };
}
